var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 115.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "turn-left-arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.88,116V78.14c0-18.66-2.57-32.35-11.19-42.15-8.84-10-22.31-14.32-43.51-13.42v0H49.36V5.66c-.11-2.24-.87-3.84-2.27-4.77-3.52-2.35-7,.44-9.53,2.69-7.3,6.51-31.36,25-35.44,28.54a5.58,5.58,0,0,0,0,8.76c4,3.38,27.21,21.08,34.72,27.89,2.66,2.39,6.43,5.89,10.25,3.35,1.4-.93,2.16-2.53,2.27-4.78V48.29H68.18l.55,0c13-.6,20.28.91,23.65,4.75,3.66,4.16,4.76,12.63,4.76,25.15V116Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.ab6ae6775d0d946ede36464572d9cdbc.svg";
export { ForwardRef as ReactComponent };